import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, Grid, Typography, FormControlLabel, Switch } from "@mui/material";
import api from '../../Api/apiAxios';
import Mensagem from '../../Components/Mensagem';
import { ButtonBase, FormSectionTitle } from '../Pedidos/styles';
import Loading from '../../Components/Loading';

export function PreferenciasEmail() {
  const [preferencias, setPreferencias] = useState({
    id: 0,
    receberAlteracaoValorContrato: false,
    receberAlteracaoNegociacao: false,
    receberAlteracaoServico: false,
    receberPedidoLiberadoPonto: false,
    receberPedidoLiberadoAcesso: false,
    receberPedidoLiberadoFolha: false,
    receberServicoSemCodigoSisdm: false,
  });

  const [mensagem, setMensagem] = useState('');
  const [tipoMensagem, setTipoMensagem] = useState('');
  const [showMensagem, setShowMensagem] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  async function getPreferenciasEmail() {
    const userId = window.localStorage.getItem('idUsuario');
    if (!userId) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await api.get(`/UsuarioPreferenciasEmail/${userId}`);

      if (response.data) {
        setPreferencias({
          id: response.data.id || 0,
          receberAlteracaoValorContrato: response.data.receberEmailAlteracaoValorContrato,
          receberAlteracaoNegociacao: response.data.receberEmailAlteracaoNegociacaoContrato,
          receberAlteracaoServico: response.data.receberEmailAlteracaoServico,
          receberPedidoLiberadoPonto: response.data.receberEmailPedidoLiberadoPonto || false,
          receberPedidoLiberadoAcesso: response.data.receberEmailPedidoLiberadoAcesso || false,
          receberPedidoLiberadoFolha: response.data.receberEmailPedidoLiberadoFolha || false,
          receberServicoSemCodigoSisdm: response.data.receberEmailServicoSemCodigoSisdm || false,
        });
      }
    } catch (e) {
      if (e?.response?.status !== 404) {
        console.log(e);
      }
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getPreferenciasEmail();
  }, []);

  const handleChangePreferencia = (campo) => (event) => {
    setPreferencias((prev) => ({
      ...prev,
      [campo]: event.target.checked,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setShowMensagem(false);
    setIsSaving(true);

    try {
      const userId = window.localStorage.getItem('idUsuario');

      const regPreferencias = {
        id: preferencias.id || 0,
        usuarioId: Number(userId),
        receberEmailAlteracaoValorContrato: preferencias.receberAlteracaoValorContrato,
        receberEmailAlteracaoNegociacaoContrato: preferencias.receberAlteracaoNegociacao,
        receberEmailAlteracaoServico: preferencias.receberAlteracaoServico,
        receberEmailPedidoLiberadoPonto: preferencias.receberPedidoLiberadoPonto,
        receberEmailPedidoLiberadoAcesso: preferencias.receberPedidoLiberadoAcesso,
        receberEmailPedidoLiberadoFolha: preferencias.receberPedidoLiberadoFolha,
        receberEmailServicoSemCodigoSisdm: preferencias.receberServicoSemCodigoSisdm,
      };

      const ret = await api.put(
        "UsuarioPreferenciasEmail/",
        regPreferencias,
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (ret.status === 200 || ret.status === 201) {
        setMensagem("Preferências de e-mail salvas com sucesso!");
        setTipoMensagem("success");

        if (ret.data && ret.data.id) {
          setPreferencias((prev) => ({ ...prev, id: ret.data.id }));
        }
      } else {
        setMensagem("Ops, algo deu errado! Atualize a página e tente novamente...");
        setTipoMensagem("danger");
      }
    } catch (e) {
      console.error(e);
      setMensagem("Ops, algo deu errado! Atualize a página e tente novamente...");
      setTipoMensagem("danger");
    } finally {
      setIsSaving(false);
      setShowMensagem(true);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <Container sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {showMensagem && (
        <Mensagem
          mensagem={mensagem}
          setMensagem={setMensagem}
          variant={tipoMensagem}
        />
      )}

      <Box
        sx={{
          backgroundColor: 'white',
          py: 3,
          px: 4,
          margin: '10px auto',
          borderRadius: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          width: '50%',
          position: 'relative',
          top: 100,
          maxHeight: '80vh',
          boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.25)',
        }}
      >
        <FormSectionTitle label="Preferências de envio de E-mail" />

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <Typography variant="h6">
                Quero receber e-mail quando:
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={preferencias.receberAlteracaoValorContrato}
                    onChange={handleChangePreferencia('receberAlteracaoValorContrato')}
                    name='receberAlteracaoValorContrato'
                  />
                }
                label="contratos mudarem de valor ou serem cancelados"
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={preferencias.receberAlteracaoNegociacao}
                    onChange={handleChangePreferencia('receberAlteracaoNegociacao')}
                    name="receberAlteracaoNegociacao"
                  />
                }
                label="negociações forem incluídas/editadas/canceladas"
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={preferencias.receberAlteracaoServico}
                    onChange={handleChangePreferencia('receberAlteracaoServico')}
                    name="receberAlteracaoServico"
                  />
                }
                label="serviços forem liberados/cancelados"
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={preferencias.receberServicoSemCodigoSisdm}
                    onChange={handleChangePreferencia('receberServicoSemCodigoSisdm')}
                    name="receberServicoSemCodigoSisdm"
                  />
                }
                label="serviço for liberado sem código SISDM válido"
              />
            </Grid>

            <Grid item xs={12} sx={{ pl: 2 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      preferencias.receberPedidoLiberadoPonto ||
                      preferencias.receberPedidoLiberadoAcesso ||
                      preferencias.receberPedidoLiberadoFolha
                    }
                    onChange={(event) => {
                      const ativo = event.target.checked;
                      setPreferencias((prev) => ({
                        ...prev,
                        receberPedidoLiberadoPonto: ativo,
                        receberPedidoLiberadoAcesso: ativo,
                        receberPedidoLiberadoFolha: ativo,
                      }));
                    }}
                    name="pedidosLiberadosMaster"
                  />
                }
                label="pedidos forem liberados"
              />
            </Grid>

            {(preferencias.receberPedidoLiberadoPonto ||
              preferencias.receberPedidoLiberadoAcesso ||
              preferencias.receberPedidoLiberadoFolha) && (
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'row', 
                gap: 2, 
                p: 2, 
                border: '1px solid #ccc', 
                borderRadius: 2,
                width: '100%',
              }}>
                <Grid item xs={12} sx={{ ml: 2 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={preferencias.receberPedidoLiberadoPonto}
                        onChange={handleChangePreferencia('receberPedidoLiberadoPonto')}
                        name="receberPedidoLiberadoPonto"
                      />
                    }
                    label="pedidos ponto"
                  />
                </Grid>

                <Grid item xs={12} sx={{ ml: 2 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={preferencias.receberPedidoLiberadoAcesso}
                        onChange={handleChangePreferencia('receberPedidoLiberadoAcesso')}
                        name="receberPedidoLiberadoAcesso"
                      />
                    }
                    label="pedidos acesso"
                  />
                </Grid>

                <Grid item xs={12} sx={{ ml: 2 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={preferencias.receberPedidoLiberadoFolha}
                        onChange={handleChangePreferencia('receberPedidoLiberadoFolha')}
                        name="receberPedidoLiberadoFolha"
                      />
                    }
                    label="pedidos folha"
                  />
                </Grid>
              </Box>
            )}

            <Grid item xs={6} />

            <Grid item xs={3}>
              <ButtonBase
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                disabled={isSaving}
              >
                Salvar
              </ButtonBase>
            </Grid>

            <Grid item xs={3}>
              <ButtonBase
                variant="outlined"
                color="primary"
                onClick={() => navigate(-1)}
                fullWidth
                sx={{ mt: 2 }}
              >
                Voltar
              </ButtonBase>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Container>
  );
}
